























import { Component, Prop, Vue } from 'vue-property-decorator'
import { SourceCodeServiceUser } from '@/services/sourceCode/SourceCodeService'
import { useSourceCodeRepositories, useSourceCodeRepositoriesReturn } from '@/store/modules/sourceCode/repositories'
import UserRepository from '@/components/UserRepository/index.vue'
import ErrorMessage from '@/components/ErrorMessage/index.vue'

@Component({
  components: {
    UserRepository,
    ErrorMessage
  },
  setup() {
    const {
      repositories,
      isLoading,
      getUserRepositories,
      hasError,
      errorMessage
    } = useSourceCodeRepositories()

    return { repositories, isLoading, getUserRepositories, hasError, errorMessage }
  }
})
export default class UserRepositories extends Vue {
  @Prop(Object) readonly user!: SourceCodeServiceUser

  repositories!: useSourceCodeRepositoriesReturn['repositories']['value']
  isLoading!: useSourceCodeRepositoriesReturn['isLoading']['value']
  hasError!: useSourceCodeRepositoriesReturn['hasError']['value']
  errorMessage!: useSourceCodeRepositoriesReturn['errorMessage']['value']
  getUserRepositories!: useSourceCodeRepositoriesReturn['getUserRepositories']

  mounted(): void {
    this.loadUserRepositories()
  }

  get title(): string {
    const repositoriesCount = this.repositories.length
    const { login: userName } = this.user

    if (this.isLoading) {
      return `Loading ${userName} repositories...`
    }

    return `${userName} has ${repositoriesCount} repositories`
  }

  async loadUserRepositories(): Promise<void> {
    await this.getUserRepositories(this.user)
  }
}
